// assets
import { HomeOutlined } from '@ant-design/icons';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

// icons
const icons = {
    HomeOutlined,
    DescriptionOutlinedIcon
};

// ==============================|| MENU ITEMS - PUBLIC PAGES ||============================== //

const root = {
    id: 'publicPages',
    title: 'Navigation',
    type: 'group',
    children: [
        {
            id: 'home',
            title: 'Home',
            type: 'item',
            url: '/dash',
            icon: icons.HomeOutlined,
            breadcrumbs: false,
        },

    ],
};

export default root;
